import { tv } from 'tailwind-variants';

export const alert = tv({
  base: 'flex px-4 py-2 rounded-md text-left items-center gap-md font-poppins shadow-level-1 text-sm overflow-hidden border-hairline',
  variants: {
    size: {
      small: 'h-4',
      regular: 'h-4',
      large: 'h-4',
    },
    variant: {
      info: 'bg-color-lighter text-mono-color-black',
      warning: 'bg-feedback-color-warning-lightest text-card-color-negative',
      error: 'bg-feedback-color-error-lightest text-mono-color-black',
      success: 'bg-feedback-color-success-lightest text-mono-color-black',
    },
  },
});

export const alertIcon = tv({
  base: '',
  variants: {
    size: {
      small: 'h-4',
      regular: 'h-6',
      large: 'h-8',
    },
    variant: {
      info: 'fill-button-color-tertiary-default',
      warning: 'fill-feedback-color-warning-pure',
      error: 'fill-feedback-color-error-darkest',
      success: 'fill-feedback-color-success-darkest',
    },
  },
});
